
<ng-container *transloco="let t">
<div class="topbar">
 
  <div class="topbar-wrapper" [class.topbar-wrapper-center]="!loadedState()">

  <div class="nav-bar">
    <div class="logo">
    
      @if (screenTypeState()==='desktop') {
        <img [src]="'assets/images/logos/_logo-'+activeLangCodeState()+'.svg'" alt="logo" />
      }

      @else if(screenTypeState()==='mobile') {
      <img src="assets/images/logos/_logo-standalone.svg" alt="logo"/>
      }
    </div>
  </div>


  <div class="topbar-actions" [ngSwitch]="screenTypeState()">
    @if (loadedState()) {
    <a [href]="'https://tbcinsurance-website-files.s3.eu-west-1.amazonaws.com/wordings/SmeWebSiteVideoInstruction.mp4'"target="_blank">
    <app-button 
      [className]="'btn img-right img-right-mobile'"
      [customIconRight]="'../../../../../assets/images/svgs/_video-instruction.svg'"
      [text]="'Instruction'"
      [customIconRightWidth]="screenTypeState()==='mobile'?'32':'40'"
      [customIconRightHeight]="screenTypeState()==='mobile'?'32':'40'">
    </app-button>
    </a>
    
      <div #lang (click)="changeLanguage(lang)"  onKeyPress class="lang-switcher">
        <img width="16" height="16" src="../../../../../assets/images/svgs/_globe.svg" alt="Globe" />
        <p>{{langDisplaySymbol()}}</p>
      </div>
  }
  </div>
  </div>

</div>

</ng-container>
